import type { AdminApiLicenseProductUtilization } from "@repo/app-types/entities/entitlement";
import {
  getTeammateLicenseTypeForProductKey,
  type TeammateLicenseType,
} from "@repo/app-types/entities/teammate";

export interface TeammateLicenseCopy {
  label: string;
  capability: string;
}

export const teammateLicenseCopy: Record<
  TeammateLicenseType,
  TeammateLicenseCopy
> = {
  teammate: {
    label: "Teammate",
    capability: "Standard performance license.",
  },
  teammate_lite: {
    label: "Teammate (lite)",
    capability: "Performance license with fewer included audio minutes.",
  },
  manager: {
    label: "Manager",
    capability: "For managers who review and coach rather than take calls.",
  },
};

/**
 * The license tiers an admin can designate teammates into: exactly the
 * performance products on the company's contract, in the utilization
 * payload's catalog order. The picker (and its column) only shows when there
 * are two or more.
 */
export function getLicenseTypeOptions(
  products: readonly AdminApiLicenseProductUtilization[],
): TeammateLicenseType[] {
  return products.map((product) =>
    getTeammateLicenseTypeForProductKey(product.product_key),
  );
}
